var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['status-icon', _vm.statusClass],style:({
    height: `${_vm.size / 10}rem`,
    width: `${_vm.size / 10}rem`,
    fontSize: `${_vm.size}px`
  })},[_c('i',{staticClass:"symbol"})])
}
var staticRenderFns = []

export { render, staticRenderFns }